import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202603: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202603",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2026-03-01",
    endDate: "2026-03-31",
    impressions: 6324,
    clicks: 88,
    adsSpendDollars: 363,
    budgetDollars: 500,
    salesDollars: 3834,
    bestEstimateRoas: 10.56,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.73,
    reorderConversions: 8,
    dataAvailableAtDate: "2026-04-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
